import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('ssring_affected_services_in_issue_view');
	},
};
